import {Descriptions, Tag} from "antd";
import dayjs from "dayjs";
import DOMPurify from "dompurify";

const STATUS_MAP = {
	upcoming:    {label: 'Sắp diễn ra',  color: 'processing'},
	in_progress: {label: 'Đang diễn ra', color: 'blue'},
	overdue:     {label: 'Quá giờ',      color: 'orange'},
	trained:     {label: 'Đã đào tạo',   color: 'success'},
	not_trained: {label: 'Chưa đào tạo', color: 'error'},
	postponed:   {label: 'Đời lịch',     color: 'warning'},
	cancelled:   {label: 'Đã hủy',       color: 'default'},
};

const TYPE_LABELS = {
	all:            'Toàn bộ phòng KD',
	by_group:       'Theo phòng',
	by_level:       'Theo cấp',
	by_designation: 'Theo chỉ định',
};

const LEVEL_LABELS = {
	truong_phong: 'Trưởng phòng',
	quan_ly:      'Quản lý',
	nhom_truong:  'Nhóm trưởng',
};

function formatDateTime(ts) {
	if (!ts) return '—';
	return dayjs.unix(ts).format('DD/MM/YYYY HH:mm');
}

function renderAudience(item) {
	if (item.type === 'by_group') {
		return (item.groups || []).map(g => g.name).join(', ') || '—';
	}
	if (item.type === 'by_level') {
		return (item.levels || []).map(l => LEVEL_LABELS[l] || l).join(', ') || '—';
	}
	if (item.type === 'by_designation') {
		return (item.designees || []).map(u => `${u.firstname} ${u.lastname}`).join(', ') || '—';
	}
	return 'Toàn bộ phòng kinh doanh';
}

function TrainingScheduleDetail({item}) {
	if (!item?.id) return null;

	const ds  = item.displayStatus || {};
	const cfg = STATUS_MAP[ds.key] || {label: ds.label || item.status, color: 'default'};

	return (
		<Descriptions column={1} bordered size="small" className="pd-2">
			<Descriptions.Item label="Chủ đề">{item.topic}</Descriptions.Item>
			<Descriptions.Item label="Trạng thái">
				<Tag color={cfg.color}>{cfg.label}</Tag>
			</Descriptions.Item>
			<Descriptions.Item label="Người đào tạo">
				{item.trainer ? `${item.trainer.firstname} ${item.trainer.lastname}` : '—'}
			</Descriptions.Item>
			<Descriptions.Item label="Bắt đầu">{formatDateTime(item.startTime)}</Descriptions.Item>
			<Descriptions.Item label="Kết thúc">{formatDateTime(item.endTime)}</Descriptions.Item>
			<Descriptions.Item label="Đối tượng">
				<div><b>{TYPE_LABELS[item.type] || item.type}</b></div>
				<div>{renderAudience(item)}</div>
			</Descriptions.Item>
			{item.content && (
				<Descriptions.Item label="Nội dung">
					<div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(item.content)}} />
				</Descriptions.Item>
			)}
		</Descriptions>
	);
}

export default TrainingScheduleDetail;
